import { render, staticRenderFns } from "./HighValueShipmentBuilder.vue?vue&type=template&id=0f09b4ca&scoped=true"
import script from "./HighValueShipmentBuilder.vue?vue&type=script&lang=js"
export * from "./HighValueShipmentBuilder.vue?vue&type=script&lang=js"
import style0 from "./HighValueShipmentBuilder.vue?vue&type=style&index=0&id=0f09b4ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f09b4ca",
  null
  
)

export default component.exports